import type { ChatTurnProps } from "../../types/chat";

// A screen that hands the user straight back (e.g. a stale KycRequired
// sending them to /kyc, which is already done) would loop on every open: the
// chat asks instead when it opened the screen moments ago.
const REOPEN_AFTER_MS = 10_000;
let lastOpenedAt = 0;

// The offer request opens its screen straight away: after KYC that is the
// ANAF waiting screen, or whatever the request still needs first.
export const getOfferRequestScreen = (props: ChatTurnProps): string | null =>
  Date.now() - lastOpenedAt > REOPEN_AFTER_MS
    ? props.step.screen.entry(props.facts)
    : null;

export const markOfferRequestScreenOpened = () => {
  lastOpenedAt = Date.now();
};
